var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { translate, useToastService } from '@lucidlink/uicore';
import { usePlugFilespaceClient } from '#query-hooks';
import { GuestLinkKeyFactory } from '../query-key-factories/GuestLinkKeyFactory';
export const useDeleteGuestLink = ({ filespaceId, workspaceId, }) => {
    _react_refresh_temp_1();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const { addToast } = useToastService();
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (guestLinkId) => plugFilespaceClient({
            action: (fsClient) => fsClient
                .guestLinksManagement()
                .deleteGuestLink(guestLinkId),
            filespaceId,
            workspaceId,
        }),
        onError: () => {
            addToast({
                'data-testid': 'delete-guest-link-error',
                kind: 'negative',
                content: {
                    message: translate('Failed to delete guest link'),
                },
            });
        },
        onSuccess: () => {
            addToast({
                'data-testid': 'delete-guest-link-success',
                kind: 'positive',
                content: {
                    message: translate('Guest link deleted'),
                },
            });
        },
        onSettled: () => queryClient.refetchQueries({
            queryKey: GuestLinkKeyFactory.list({
                filespaceId,
                workspaceId,
            }),
        }),
        networkMode: 'always',
    });
    return mutation;
};
_react_refresh_temp_1(useDeleteGuestLink, "KrM3mhTkTlZAjWS6DCmlJKC0EYA=", false, () => [usePlugFilespaceClient, useToastService, useQueryClient, useMutation]);
